import React, { FC, ReactNode } from 'react';
import { LoadingOverlay } from '@abyss/web/ui/LoadingOverlay';
import { LoadingPositionFixed } from './styles';

interface Props {
  children: ReactNode;
}

export const Loader: FC<Props> = ({ children }) => {
  return (
    <LoadingOverlay
      model="crdp-loading"
      loadingTitle="Please Wait"
      loadingMessage="Retrieving Information."
      isOpen
      css={LoadingPositionFixed}
      width="350px"
      isLoading
    >
      {children}
    </LoadingOverlay>
  );
};
